export default (serviceData) => !!serviceData;
